import { watch } from 'vue'
import { createWebHistory, createRouter } from 'vue-router'
import baseRoutes from './base'
import { useConfigStore } from '@/stores/modules/config.js'
import { useUserStore } from '@/stores/modules/user'
import i18n from '@/lang'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_BASE),
  routes: baseRoutes
})

const getTitle = (title) => {
  const configStore = useConfigStore()
  const systemName = configStore.AgentName || i18n.global.t('common.title')
  return `${systemName} ${title ? '| ' + title : ''}`.trim()
}

const resolveRouteTitle = (to) => {
  let title = to.meta.title ? i18n.global.t(to.meta.title) : '' // 默认取路由配置
  if (to.query.title) {
    title = to.query.title || title
  }
  return title
}

// 路由拦截
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  // 初始化时缓存参数
  if (to.name === 'init') {
    userStore.initQuery(to.query)
  }
  // 等待系统配置加载完成
  const configStore = useConfigStore()
  await configStore.fetchReady
  to.meta.from = from.name
  next()
})

// 路由完成后设置 title，并通过 watch 响应 config 加载完成
router.afterEach((to) => {
  const configStore = useConfigStore()
  const title = resolveRouteTitle(to)
  document.title = getTitle(title)

  // 如果配置尚未加载，监听配置变化后自动更新 title
  if (configStore.loading) {
    const stop = watch(
      () => configStore.AgentName,
      () => {
        document.title = getTitle(resolveRouteTitle(router.currentRoute.value))
        stop()
      }
    )
  }
})

export default router